import http from '@/utils/http'

//在线表决列表
export function voteList(pageInfo) {
    return http.get("/api/maintenance-fund/weixin/voteList", {
        params: pageInfo
    })
}

//在线交存（交存申请）----支付
export function houseDepositPay(subAccount) {
    return http.post("api/maintenance-fund/weixin/houseDepositPay", subAccount)
}


//在线交存（交存申请）----交存申请
export function depositApply(param) {
    return http.post("/api/maintenance-fund/weixin/depositApply", param)
}

//在线交存（交存申请）---- 绑定房屋
export function bindHouse(contractNo) {
    return http.get("/api/maintenance-fund/weixin/bindHouse/" + contractNo)
}


//我的房屋-房屋详情
export function houseInfo(houseId) {
    return http.get("/api/maintenance-fund/weixin/houses/" + houseId)
}

//我的房屋列表
export function myHousesList(pageInfo) {
    return http.get("/api/maintenance-fund/weixin/myHousesList", {
        params: pageInfo
    })
}

//核心系统数据-我的房屋列表
export function myHouseList() {
    return http.get("/api/maintenance-fund/weixin/houses")
}

//网签合同-
export function myHtHouseList() {
    return http.get("/api/maintenance-fund/weixin/housesDeposit")
}
// 绑定房屋
export function userHouses(userHouse) {
    return http.post("/api/maintenance-fund/weixin/userHouses", userHouse)
}

export function ownerConfirm(owner) {
    return http.post("/api/maintenance-fund/weixin/ownerConfirm", owner)
}

export function regions(params) {
    return http.get("/api/maintenance-fund/weixin/fetchRegions", {
        params: params
    })
}

export function fetchBldCellHouses(params) {
    return http.get("/api/maintenance-fund/weixin/fetchBldCellHouses", {
        params: params
    })
}

//在线交存（交存申请）----交存申请
export function eSignCheck(param) {
    return http.post("/api/maintenance-fund/weixin/eSignCheck", param)
}

export function eSignBegin(param) {
    return http.post("/api/maintenance-fund/weixin/eSignBegin", param)
}

export function checkESign(param) {
    return http.post("/api/maintenance-fund/weixin/checkESign", param)
}

export function signerChack(param) {
    return http.post("/api/maintenance-fund/weixin/signerChack", param)
}

export function updateESignMobile(param) {
    return http.post("/api/maintenance-fund/weixin/updateESignMobile", param)
}

export function signCommit(param) {
    return http.post("/api/maintenance-fund/weixin/signCommit", param)
}

export function checkRegion(houseId) {
    return http.get("/api/maintenance-fund/weixin/checkRegion/" + houseId)
}

export function getAgreeList() {
    return http.get("/api/maintenance-fund/weixin/getAgreeList")
}

export function flowCancel(param){
    return http.post("/api/maintenance-fund/weixin/flowCancel", param)
}

export function findSignStatus(depAgreeId) {
    return http.get("/api/maintenance-fund/weixin/findSignStatus/"+depAgreeId)
}

export function downloadPdf(param) {
    return http.download("/api/maintenance-fund/weixin/sigeAgreePdf",param)
}

export function getDepositMessage(param) {
    return http.post("/api/maintenance-fund/weixin/depositApply2",param)
}

export function getSignDepositList(query) {
    return http.get('/api/maintenance-fund/weixin/deposit/signBillList', {
        params: query
    })
}





export function getDocTypeByBusiType(params) {
    return http.get("/api/maintenance-fund/weixin/getDocTypeByBusiType", {
        params: params
    })
}

export function changeApply(params) {
    return http.post("/api/maintenance-fund/weixin/changeApply", params)
}

//业主变更图档上传
export function uploadImg(param) {
    return http.post("/api/maintenance-fund/weixin/uploadImg", param)
}

//行政区划查询
export function queryDivisionList(params) {
    return http.get("/api/portal/weixin/division/list", {
        params: params
    })
}

//查询用途查询
export function queryPurposeList(params) {
    return http.get("/api/portal/weixin/purpose/list", {
        params: params
    })
}

//查询网签数据
export function onlineSineQuery(params) {
    return http.post("/api/portal/weixin/purpose/onlineSineQuery", params)
}

//业务办理预约提交
export function submitBusiPrebookinfoApply(params) {
    return http.post("/api/portal/weixin/busiPrebookinfoApply", params)
}
//不动产权证 和 购房合同 文件上传
export function uploadBusiPrebookinfoFile(params) {
    return http.post("/api/portal/weixin/uploadBusiPrebookinfoFile", params)
}

//我的预约列表查询
export function queryMyBusiPrebookList(params) {
    return http.get("/api/portal/weixin/queryMyBusiPrebookList",  {
        params: params
    })
}

//业主信息变更信息查询
export function fetchAuditOwnerInfo() {
    return http.get("/api/maintenance-fund/weixin/getOwnerChangeList")
}
